document.addEventListener('turbo:load', function(e) {

  /* --------------------------------------------------
                Note Init
  -------------------------------------------------- */
  pgNotesInit = function(){
    let noteSelector = '[data-js="note"]';
    let noteEdits = document.querySelectorAll(`${noteSelector} [data-js="note-edit"]`);
    let noteDetailsFormCancels = document.querySelectorAll(`${noteSelector} [data-js="note-cancel"]`);
    let noteContent = '[data-js="note-content"]';
    let noteForm = '[data-js="note-form"]';
    let noteEditLink = '[data-js="note-edit-link"]';

    Array.prototype.forEach.call(noteEdits, function(el, i) {
      if (!el.hasAttribute('data-initialized')) {
        el.addEventListener('click', (e) => {
          const noteEl = el.closest(noteSelector);
          noteEl.querySelector(noteContent).classList.add('hidden');
          noteEl.querySelector(noteForm).classList.remove('hidden');
          noteEl.querySelector(noteEditLink).classList.add('hidden');
          e.preventDefault();
        });
        el.setAttribute('data-initialized', 'true');
      }
    });
    Array.prototype.forEach.call(noteDetailsFormCancels, function(el, i) {
      if (!el.hasAttribute('data-initialized')) {
        el.addEventListener('click', (e) => {
          const noteEl = el.closest(noteSelector);
          noteEl.querySelector(noteContent).classList.remove('hidden');
          noteEl.querySelector(noteForm).classList.add('hidden');
          noteEl.querySelector(noteEditLink).classList.remove('hidden');
          e.preventDefault();
        });
        el.setAttribute('data-initialized', 'true');
      }
    });
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pgNotesInit();
});
